import { getArticlesByPlayerId } from '../general/js/services/live-card-articles-service';

const ARTICLES_RECEIVE = 'ARTICLES_RECEIVE';

const reducer = (state = {}, action) => {
    switch (action.type) {
        case ARTICLES_RECEIVE:
            if (action.payload.items.length) {
                return {
                    ...state,
                    [action.callbackUrl]: action.payload,
                };
            }
            return state;

        default:
            return state;
    }
};

export default reducer;

export const receiveArticles = (callbackUrl, data) => ({
    type: ARTICLES_RECEIVE,
    callbackUrl,
    payload: data
});

export const fetchArticlesFeed = (callbackUrl) => (dispatch) => {
    getArticlesByPlayerId({ callbackUrl })
        .then((data) => {
            dispatch(receiveArticles(callbackUrl, data));
        });
};
